import { h } from "preact";
import useFormStore from "../../store/useFormStore";

export default function FranchiseDisclaimerBlock() {
  const selectedEstimateType = useFormStore(
    (state) => state.selectedEstimateType,
  );

  // Only show this disclaimer when estimate type is 'on_site_estimate'
  if (selectedEstimateType !== "on_site_estimate") {
    return null;
  }

  return (
    <div className="franchise-disclaimer-block p-4 bg-coit-yellow">
      <div className="text-2xl font-bold">This Service Request</div>
      <p>
        You are scheduling a <strong>Free In-Home Consultation Appointment</strong>.
        A COIT Professional Consultant will assess your cleaning needs and
        provide a free, no-obligation written estimate. If you approve the
        estimate, <strong>you can schedule the cleaning service at your convenience</strong>.
      </p>
    </div>
  );
}
